import {Action, getModule, Module, VuexModule} from "vuex-module-decorators";
import ModuleApi from "@/store/api";
import {AppointmentDto, AppointmentRs} from "@/types/appointments";
import store from "@/store";
import {mapToAppointmentDto, mapToUpdateAppointmentRq} from "@/mappers/appointments";
import * as url from "url";

@Module({
    name: 'appointments',
    dynamic: true,
    namespaced: true,
    store,
})
class ModuleAppointments extends VuexModule {
    @Action
    async getAllAppointments() {
        const response = await ModuleApi.GET('/api/cabinet/appointments/') as AppointmentRs[]
        return response
            //TODO: подумать о сортировке и как работать с запросами без конкретного времени(тип by_email)
            .filter(slot => slot.appointmentDate !== '' && slot.appointmentDate !== null && slot.appointmentDate !== undefined)
            .toSorted((a, b) => a.appointmentDate.localeCompare(b.appointmentDate))
            .map(appointment => mapToAppointmentDto(appointment))
    }

    @Action
    async getAllAppointmentByClientId(clientId: string) {
        const response = await ModuleApi.GET(`/api/cabinet/appointments/by-user/${clientId}`) as AppointmentRs[]
        return response
            .filter(slot => slot.appointmentDate !== '' && slot.appointmentDate !== null && slot.appointmentDate !== undefined)
            .toSorted((a, b) => a.appointmentDate.localeCompare(b.appointmentDate))
            .map(appointment => mapToAppointmentDto(appointment))
    }

    @Action
    async updateAppointment(appointment: AppointmentDto) {
        const request = mapToUpdateAppointmentRq(appointment);
        const response = await ModuleApi.PUT({url: '/api/cabinet/appointments/update', body: request}) as AppointmentRs;
        return mapToAppointmentDto(response)
    }
}

export default getModule(ModuleAppointments)
